module.exports = __webpack_public_path__ + "img/terminals.ea998142.svg";